<template>
    <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10 8.286a.635.635 0 0 1-.053.271.67.67 0 0 1-.614.443H2.666a.66.66 0 0 1-.614-.443.742.742 0 0 1 .147-.778l3.327-3.57a.633.633 0 0 1 .94 0L9.8 7.779a.746.746 0 0 1 .193.507H10z"
        />
    </svg>
</template>
